export default function CTA() {
  return (
    <div className="cta">
      <a href="#work" className="btn">
        View work
      </a>
      <a href="#contact" className="btn btn-primary">
        Contact me
      </a>
    </div>
  );
}
